import action from './node/action'
import actionset from './node/actionset'
import automation from './node/automation'
import enabler from './node/enabler'
import aspect from './node/aspect'
import field from './node/field'
import nodelock from './node/nodelock'
import filter from './node/filter'
import security from './node/security'
import classification from './node/classification'
import clearance from './node/clearance'
import grant from './node/grant'
import nodetoken from './node/nodetoken'
import defaulticon from './node/defaulticon'
import history from './node/history'

export default {
  action,
  actionset,
  automation,
  enabler,
  aspect,
  field,
  nodelock,
  filter,
  security,
  classification,
  clearance,
  grant,
  nodetoken,
  defaulticon,
  history,
}
